module.exports = __webpack_public_path__ + "media/images/flags/16/Cook-Islands-5c26b9d5cadda92cb9e14b6b1dc02140.png";